import { ChevronDown } from "lucide-react";
import type { ComponentProps } from "react";

import { controlClass, controlHeight } from "@/components/ui/field";
import { cn } from "@/utils/utils";

/**
 * A native `<select>` behind the shared control shell.
 *
 * Native means the platform picker on a phone, keyboard behaviour for free, and
 * nothing to get wrong about focus. The chevron is ours; the list is the
 * browser's.
 */
export function Select({
  className,
  placeholder,
  fieldSize = "md",
  children,
  ...props
}: ComponentProps<"select"> & {
  placeholder?: string;
  fieldSize?: keyof typeof controlHeight;
}) {
  return (
    <div className="relative">
      <select
        className={cn(
          controlClass,
          controlHeight[fieldSize],
          "cursor-pointer appearance-none pr-9",
          className,
        )}
        {...props}
      >
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="text-fg-subtle pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2"
      />
    </div>
  );
}
